export default "__VITE_ASSET__19190974__"